import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { Link } from "react-router-dom";
import { TeamMemberLevel, UserType } from "sprout-graphql";
import { Button } from "sprout-ui-dom";
import { Add, LeafLine } from "sprout-ui-icons";
import { Flex, Text } from "sprout-ui-primitives";
import styled from "styled-components";
import ProfilePageUserHeaderActionButton from "./ProfilePageUserHeaderActionButton";
import useProfileAuthorization from "./useProfileAuthorization";
const ProfilePageUserHeaderBottomButtonsWrapper = styled(Flex)`
  > * + * {
    margin-left: 16px;
  }
`;
const ProfilePageUserHeaderBottomButtons = (props)=>{
    const { user  } = props;
    const { username , id , memberLevel , type  } = user;
    const authorization = useProfileAuthorization(user);
    const isOwnerOrAdmin = memberLevel === TeamMemberLevel.Owner || memberLevel === TeamMemberLevel.Admin;
    const currentUser = useCurrentUser();
    const isCurrentUser = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) === id;
    return /*#__PURE__*/ _jsxs(ProfilePageUserHeaderBottomButtonsWrapper, {
        alignItems: "center",
        justifyContent: "center",
        mt: 4,
        children: [
            isOwnerOrAdmin || isCurrentUser ? /*#__PURE__*/ _jsxs(Button, {
                variant: "purple",
                as: Link,
                to: type === UserType.Team ? `/${username}/workspace/leaves` : `/${username}/leaves`,
                children: [
                    /*#__PURE__*/ _jsx(LeafLine, {}),
                    /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        ml: 0,
                        children: "Public leaves"
                    })
                ]
            }) : /*#__PURE__*/ _jsx(ProfilePageUserHeaderActionButton, {
                user: user
            }),
            authorization.inviteUsers && /*#__PURE__*/ _jsxs(Button, {
                variant: "purple",
                as: Link,
                to: `/${username}/invite`,
                children: [
                    /*#__PURE__*/ _jsx(Add, {}),
                    /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        ml: 0,
                        children: "Invite people"
                    })
                ]
            })
        ]
    });
};
export default ProfilePageUserHeaderBottomButtons;
